export default {
    isLoggedIn: function (state) {
        return state.token ? true : false
    },
    isAdmin: function (state) {
        if (!state.user) {
            return false
        }
        return state.user.admin === 1 ? true : false
    },
    isStandard: function (state) {
        if (!state.user) {
            return false
        }
        return state.user.membership_type === "standard"
    },
    isPlus: function (state) {
        if (!state.user) {
            return false
        }
        return state.user.membership_type === "plus"
    },
    isPro: function (state) {
        if (!state.user) {
            return false
        }
        return state.user.membership_type === "pro"
    },
    isTrial: function (state) {
        if (!state.user) {
            return false
        }
        return state.user.membership_type === "trial"
    },
    membership: function (state) {
        if (!state.user) {
            return {}
        }
        return state.website.memberships[state.user.membership_type]
    },
    limit: function (state) {
        if (!state.user) {
            return 0
        }
        return state.user.portal_limit;
    },
    upgrade: function (state, getters) {
        if (getters["membership"].name === "standard") {
            return state.website.memberships["plus"];
        }
        if (getters["membership"].name === "plus") {
            return state.website.memberships["pro"];
        }
        return null
    },
    downgrade: function (state, getters) {

        if (getters["membership"].name === "pro") {
            return state.website.memberships["plus"];
        }
        if (getters["membership"].name === "plus") {
            return state.website.memberships["standard"];
        }
        return null
    },
    canDowngrade: function (state, getters) {
        if (!getters['downgrade']) {
            return false
        }
        return (state.portal_count <= getters['downgrade'].limit)

    },
    trial_ended: function (state) {
        if (!state.user) {
            return false;
        }
        return state.user.trial_ended;
    },
    notifications_count: function (state) {
        return state.notifications.filter(n => {
            return !n.seen
        }).length
    },
    notifications_sorted: function (state) {
        return state.notifications.sort((a, b) => {
            if (a.id < b.id) {
                return 1
            }
            if (a.id > b.id) {
                return -1
            }
            return 0
        })
    }
}